"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateEditionVault = void 0;
const web3_js_1 = require("@solana/web3.js");
const vendor_1 = require("../../../../../vendor");
const updateEditionVault = async (params) => {
    const { nftOwner, vaultAccount, newPrice, program } = params;
    await (0, vendor_1.checkSaleOngoing)(vaultAccount, program);
    const transaction = new web3_js_1.Transaction();
    const ix = await program.methods
        .updateVault(newPrice)
        .accounts({
        nftOwner: nftOwner.publicKey,
        vaultAccount
    })
        .instruction();
    transaction.add(ix);
    return (0, vendor_1.sendTx)(nftOwner, transaction, program);
};
exports.updateEditionVault = updateEditionVault;
